import React from 'react';
import InputComp from '../../../components/InputComp/InputComp';

const GuestInfoForm = ({ state, handleInputChange }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '0.4rem',
    }}
  >
    <InputComp
      value={state.adi}
      onChange={handleInputChange}
      name="adi"
      placeholder='Misafir Adı'
      error={state.adiError}
      svg='User'
    />
    <InputComp
      value={state.soyadi}
      onChange={handleInputChange}
      name="soyadi"
      placeholder='Misafir Soyadı'
      error={state.soyadiError}
      svg='UserCard'
    />
    <InputComp
      value={state.tc}
      onChange={handleInputChange}
      name="tc"
      placeholder='Misafir T.C. Kimlik No'
      error={state.tcError}
      svg='UserCard'
    />
    <InputComp
      value={state.dogumTarihi}
      onChange={handleInputChange}
      name="dogumTarihi"
      placeholder='gg/aa/yyyy'
      error={state.dogumTarihiError}
      svg='Calendar'
      type='text'
      mask='99/99/9999'
    />
    <InputComp
      value={state.tel}
      onChange={handleInputChange}
      name="tel"
      placeholder='Misafire ait telefon numarası'
      error={state.telError}
      svg='Phone'
      type='tel'
      maxlength='10'
      mask='(999) 999 99 99'
    />
  </div>
);

export default GuestInfoForm; 